export const Themes = [
    {
        id: 'LIGHT',
        name: 'Light',
        thumb: '/themes/thumbs/Light.png',
    },
    {
        id: 'DARK',
        name: 'Dark',
        thumb: '/themes/thumbs/Dark.png',
    },
    {
        id: 'SUNRISE',
        name: 'Sunrise',
        thumb: '/themes/thumbs/Sunrise.png',
        backgroundImage: '/themes/hd/Sunrise.jpg',
    },
    {
        id: 'SERENE',
        name: 'Serene',
        thumb: '/themes/thumbs/Serene.png',
        backgroundImage: '/themes/hd/Serene.jpg',
    },
    {
        id: 'BLISS',
        name: 'Bliss',
        thumb: '/themes/thumbs/Bliss.png',
        backgroundImage: '/themes/hd/Bliss.jpg',
    },
    {
        id: 'LUSH',
        name: 'Lush',
        thumb: '/themes/thumbs/Lush.png',
        backgroundImage: '/themes/hd/Lush.jpg',
    },
];
